import MenuLink from "./MenuLink";

const TasksLink = () => {
  return <MenuLink caption={"Tasks"} to="/tasks" />;
};

export default TasksLink;
